import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  InjectionToken,
  Input,
  Optional,
  Output
} from '@angular/core';

export interface OptionParentComponent {
  multiple?: boolean;
  toggle(opt: OptionComponent): void;
}

export const OPTION_PARENT_COMPONENT = new InjectionToken<OptionParentComponent>('OPTION_PARENT_COMPONENT');

export const ENTER = 13;

@Component({
  selector: 'gcc-option',
  exportAs: 'gccOption',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionComponent {
  @HostBinding('class') public className = 'gcc-option dropdown-item';

  @HostBinding('class.selected') get selected() {
    return this._selected;
  }
  @HostBinding('class.active') get active() {
    return this._active;
  }

  @HostBinding('class.disabled')
  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(value: any) {
    this._disabled = isDisabled(value);
  }
  @Input() public value: any;

  @Output() public selectionChange = new EventEmitter<OptionComponent>();

  get viewValue(): string {
    return this._element.nativeElement.innerHTML || '';
  }

  private _selected = false;
  private _active = false;
  private _disabled = false;

  constructor(
    private _element: ElementRef<HTMLElement>,
    private _changeDetectorRef: ChangeDetectorRef,
    @Optional() @Inject(OPTION_PARENT_COMPONENT) private _parent: OptionParentComponent
  ) {}

  public select(): void {
    if (!this._selected) {
      this._selected = true;
      this._changeDetectorRef.markForCheck();
    }
  }

  public deselect(): void {
    if (this._selected) {
      this._selected = false;
      this._changeDetectorRef.markForCheck();
      this.selectionChange.emit();
    }
  }

  public setActiveStyles(): void {
    if (!this._active) {
      this._active = true;
      this._changeDetectorRef.markForCheck();
    }
  }

  public setInactiveStyles(): void {
    if (this._active) {
      this._active = false;
      this._changeDetectorRef.markForCheck();
    }
  }

  @HostBinding('attr.tabindex')
  public getTabIndex() {
    return this.disabled ? '-1' : '0';
  }

  @HostListener('click')
  public selectViaInteraction(): void {
    if (!this.disabled) {
      this._parent.toggle(this);
    }
  }
}

export function isDisabled(value: any): boolean {
  return value != null && `${value}` !== 'false';
}
